import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 px-6 max-w-2xl mx-auto" data-id="element-196">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-197">
        <div className="text-center mb-16" data-id="element-198">
          <span className="text-gold-400 uppercase tracking-widest text-sm font-semibold mb-4 block" data-id="element-199">
            Introducing
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-cream-50 mb-6" data-id="element-200">
            Sleep-Shifts Survival System
          </h2>
          <p className="text-xl text-cream-100/80 max-w-lg mx-auto" data-id="element-201">
            A short, printable PDF system designed to do one thing:
          </p>
        </div>

        <div className="bg-gold-400/10 border border-gold-400/20 p-8 rounded-xl mb-16 text-center" data-id="element-202">
          <p className="text-xl md:text-2xl font-serif text-gold-400 leading-relaxed" data-id="element-203">
            Protect a real sleep block (goal: ~5 hours) even when your baby
            doesn't sleep.
          </p>
        </div>

        <div className="space-y-8 text-lg md:text-xl leading-loose-p text-cream-50 mb-16" data-id="element-204">
          <p data-id="element-205">Not by controlling the baby.</p>
          <p data-id="element-206">By controlling the only thing you can control at 2am:</p>
          <p className="font-bold text-cream-50" data-id="element-207">
            who is ON, who is OFF, and how the handoff happens.
          </p>
        </div>

        {/* Mechanism */}
        <div className="border-t border-white/10 pt-16" data-id="element-208">
          <h3 className="font-serif text-3xl text-gold-400 mb-10 text-center" data-id="element-209">
            The Unique Mechanism: Shift Architecture
          </h3>

          <div className="grid gap-6" data-id="element-210">
            {[{
            title: 'Fixed Sleep Blocks',
            desc: "so you're not renegotiating constantly"
          }, {
            title: 'A 20-Second Handoff Script',
            desc: "so the transfer doesn't turn into a fight"
          }, {
            title: 'Anti-Resentment Night Rules',
            desc: 'so you stop keeping score at 3am'
          }, {
            title: 'A Weekly Planner',
            desc: "so you can run it for 7 days without 'figuring it out' nightly"
          }].map((item, i) => <div key={i} className="flex gap-4 items-start" data-id="element-211">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gold-400 text-navy-900 flex items-center justify-center font-bold font-serif" data-id="element-212">
                  {i + 1}
                </div>
                <div data-id="element-213">
                  <h4 className="font-bold text-cream-50 text-lg" data-id="element-214">
                    {item.title}
                  </h4>
                  <p className="text-cream-100/70 italic" data-id="element-215">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <p className="text-center mt-12 text-2xl font-serif text-cream-100" data-id="element-216">
            It's not inspirational.
            <br data-id="element-217" />
            <span className="text-gold-400" data-id="element-218">It's operational.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}